module.exports = __webpack_public_path__ + "static/img/areaB_7.6e55e40.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_7.png
// module id = 1270
// module chunks = 1